
import { defineComponent, ref, Ref, onBeforeUnmount } from 'vue'
import AppHeader from '@/components/Header.vue'
import { Toast, Rate, Popup, Field } from 'vant'
import { ComponentInstance } from 'vant/lib/utils'
import getRoute from '@/compositions/route'
import { getServiceDetail } from '@/apis/fault'

export default defineComponent({
  name: 'Fault-Comment',
  components: {
    AppHeader,
    VanPopup: Popup,
    VanRate: Rate,
    VanField: Field,
  },
  setup() {
    const stars: Ref<number> = ref(0)
    const describe: Ref<string> = ref('')
    const dateTime: Ref<string> = ref('')
    const show: Ref<boolean> = ref(false)
    const { params } = getRoute()
    let _ts: number = Date.now()
    let toast: ComponentInstance = null
    const getData = async () => {
      const ts: number = _ts
      toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result: any = await getServiceDetail((params.value?.guid as string) || '')
        if (ts !== _ts) return
        const { evaluation } = result
        if (evaluation) {
          const { score, appraise, created_at } = evaluation
          stars.value = score || 0
          describe.value = appraise || ''
          dateTime.value = created_at ? created_at.slice(0, 16) : ''
        }
        toast.clear()
      } catch (err: unknown) {
        if (ts !== _ts) return
        toast.clear()
        const message: string = (err as { message: string }).message
        Toast(message)
        console.error(message)
      }
    }
    getData()
    onBeforeUnmount(() => {
      if (toast) {
        toast.clear()
        toast = null
      }
      _ts = 0
    })
    return {
      show,
      describe,
      dateTime,
      stars,
    }
  },
})
